import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ShoppingBag, Map, Smartphone, User } from "lucide-react";

const NAV = [
  { to: "/room", icon: Home, label: "Home", id: "nav-home" },
  { to: "/shop", icon: ShoppingBag, label: "Buy", id: "nav-shop" },
  { to: "/city", icon: Map, label: "Map", id: "nav-map" },
  { to: "/social", icon: Smartphone, label: "Phone", id: "nav-phone" },
  { to: "/me", icon: User, label: "Me", id: "nav-me" },
];

export default function AppShell() {
  const nav = useNavigate();
  const loc = useLocation();
  return (
    <div className="w-full flex justify-center bg-gradient-to-b from-sky-100 to-slate-200">
      <div className="relative w-full max-w-md h-[100dvh] bg-[#F8FAFC] border-x border-slate-200 overflow-hidden shadow-2xl">
        <div className="absolute inset-0 overflow-y-auto no-scrollbar pb-24">
          <Outlet />
        </div>
        <nav className={`absolute bottom-0 left-0 right-0 z-40 px-3 pb-3 ${loc.pathname === "/wardrobe" ? "hidden" : ""}`}>
          <div className="flex items-stretch justify-between bg-white/90 backdrop-blur-xl backdrop-saturate-150 border border-white/60 rounded-full shadow-[0_8px_30px_rgba(0,0,0,0.10)] px-1.5 py-1.5">
            {NAV.map((n) => {
              const active = loc.pathname === n.to || (n.to === "/me" && loc.pathname.startsWith("/player"));
              const Icon = n.icon;
              return (
                <motion.button
                  key={n.to}
                  data-testid={n.id}
                  onClick={() => nav(n.to)}
                  whileTap={{ scale: 0.9 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                  className={`flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-full transition-colors ${active ? "bg-[#16A34A] shadow-[0_6px_16px_-4px_rgba(22,163,74,0.5)]" : ""}`}
                >
                  <Icon size={21} strokeWidth={active ? 2.6 : 2} className={active ? "text-white" : "text-slate-400"} />
                  <span className={`label-xs ${active ? "text-white" : "text-slate-400"}`}>{n.label}</span>
                </motion.button>
              );
            })}
          </div>
        </nav>
      </div>
    </div>
  );
}
